exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.legend-item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-shrink: 0;\n  margin-right: 24px;\n}\n\n.legend-label {\n  font-size: 13px;\n  margin-left: 8px;\n}\n\n.the-item-container {\n  display: flex;\n}\n\n", ""]);

// exports
